<template>
    <v-container id="wish-lists-view">
        <bnft-wishlists-admin v-if="$auth.isAuthenticated && $auth.user[`https://${tld}/roles`] && $auth.user[`https://${tld}/roles`].includes('admin')"></bnft-wishlists-admin>
        <bnft-wishlists v-else></bnft-wishlists>
    </v-container>
</template>
<script>

import BnftWishlists from '../components/BnftWishlists.vue'
import BnftWishlistsAdmin from '../components/BnftWishlistsAdmin.vue'

export default {
    name: "Wishlists",
    data() {
        return {
            tld: global.tld
        }
    },
    components: {
        BnftWishlists,
        BnftWishlistsAdmin,
    },
};
</script>